export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path
      d="M20 3L34 9V20C34 28.5 28 35.5 20 38C12 35.5 6 28.5 6 20V9L20 3Z"
      fill="#0F172A"
      stroke="#38BDF8"
      strokeWidth="2"
    />
    <path
      d="M20 8V32M8 20H32M11.5 11.5L28.5 28.5M28.5 11.5L11.5 28.5"
      stroke="#38BDF8"
      strokeWidth="1.5"
      strokeLinecap="round"
      opacity="0.55"
    />
    <path d="M20 14L24 20L20 26L16 20L20 14Z" fill="#38BDF8" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    {!compact && (
      <span className="font-display text-xl font-extrabold tracking-tight">
        <span className="text-[#F8FAFC]">NORDI</span>
        <span className="text-sky-400">GUARD</span>
      </span>
    )}
  </span>
);
